export const valuesFields = {
  userLabel: "info",
  userValue: "info"
};

export const actions = [
  {
    name: "edit",
    functionName: "startEditingUser",
    fa: "fa-pencil-alt"
  }
];

export const actionsOfferCalc = [
  {
    name: "edit_OC_Access",
    functionName: "startEditingUserOCAccess",
    fa: "fa-pencil-alt"
  }
];

export const editUserData = {
  fullName: {
    type: "text"
  },
  emailAddress: {
    type: "text"
  },
  role: {
    type: "array"
  },
  canEditAccepted: {
    type: "checkbox",
    isNotRequired: true
  },
  canExportWorklog: {
    type: "checkbox",
    isNotRequired: true
  },
  acceptPersonalWorklogs: {
    type: "checkbox",
    isNotRequired: true
  },
  canImportIncome: {
    type: "checkbox",
    isNotRequired: true
  },
  canImportIncomeCountrywide: {
    type: "checkbox_reliant",
    reliantOn: "canImportIncome",
    isNotRequired: true,
    infoTooltip: true
  },
  canViewRates: {
    type: "checkbox",
    isNotRequired: true
  },
  canUpdateRates: {
    type: "checkbox_reliant",
    reliantOn: "canViewRates",
    isNotRequired: true
  },
  managementViewHidden: {
    type: "checkbox",
    isNotRequired: true
  },
  canAccess360View: {
    type: "checkbox",
    isNotRequired: true
  },
  canAccessFlexitime: {
    type: "checkbox",
    isNotRequired: true
  },
  isIntegrationAdmin: {
    type: "checkbox",
    isNotRequired: true
  },
  isLocalAdmin: {
    type: "radio",
    isNotRequired: true
  },
  isAdmin: {
    type: "radio",
    isNotRequired: true
  },
  invoicedTime: {    
    type: "checkbox",
    isNotRequired: true
  },
  projectVisibilityFromD365: {
    type: "checkbox",
    isNotRequired: true
  },
  forcePowerUser: {
    type: "checkbox",
    isNotRequired: true
  }
};

export const rowActionsRestricted = [
  {
    name: "edit_access",
    functionName: "startEditingAccess"
  },
];

export const editUserOCAccessData = {
  calcClientDataAccess: {
    type: "checkbox",
    isNotRequired: true
  },
  calcTemplatesAccess: {
    type: "checkbox",
    isNotRequired: true
  },
  calcTemplatesEditAccess: {
    type: "checkbox_reliant",
    reliantOn: "calcTemplatesAccess",
    isNotRequired: true
  },
  calcOfferBuilderAccess: {
    type: "checkbox",
    isNotRequired: true
  },
  calcGlobalBidsAccess: {
    type: "checkbox",
    isNotRequired: true
  },
  calcPgViewAccess:{
    type: "checkbox",
    isNotRequired: true
  },
  calcPgEditAccess: {
    type: "checkbox_reliant",
    reliantOn: "calcPgViewAccess",
    isNotRequired: true
  },
  directOClogin: {
    type: "checkbox",
    reliantOn: "any",
    isNotRequired: true,
    editionDisabled: false
  },
  calcGlobalTenderManager: {
    type: "checkbox",
    isNotRequired: true
  }
};

export const positionFields = {
  siteName: "info",
  seniorityLevelName: "info",
  type: "info",
  mon: "info",
  validFrom: "info",
  validFor: "info",
};

export const teamFields = {
  teamName: "info",
  when: "info"
};

export const positionActions = [
  {
    name: "new",
    functionName: "startAddingPosition",
    fa: "fa-plus"
  }
];

export const positionRowActions = [
  {
    name: "edit",
    functionName: "startEditingPosition",
    fa: "fa-pencil-alt"
  }
];

export const positionData  = {
  siteId: {
    type: "select"
  },
  seniorityLevel: {
    type: "select"
  },
  type: {
    type: "array"
  },
  standardWorkingHours: {
    type: "number"
  },
  validFrom: {
    type: "date"
  },
};

export const rateFields = {
  profitCenterName: "info",
  seniorityLevel: "info",
  validFrom: "info",
  rate: "info"
};

export const clientRestrictedFields = {
  clientName: "info",
  isAllowed: "info",
};

export const subscriptionFields = {
  profitabilitySubscription: "checkbox",
  overtimeSubscription: "checkbox",
  legalAlert: "checkbox",
  teamName: "info",
  sendAt: "info",
  language: "info"
};

export const subscriptionRowActions = [
  {
    name: "edit",
    functionName: "startEditingSubscription",
    fa: "fa-pencil-alt",
    off: (alert) => alert.legalAlert
  },
  {
    name: "edit",
    functionName: "changeAlertLanguage",
    fa: "fa-pencil-alt",
    off: (alert) => !alert.legalAlert
  },
  {
    name: "delete",
    functionName: "startDeletingSubscription",
    fa: "fa-trash",
    off: (alert) => alert.legalAlert
  },
  {
    name: "delete",
    functionName: "startDeletingAlert",
    fa: "fa-trash",
    off: (alert) => !alert.legalAlert
  },
  {
    name: "send_subscription",
    functionName: "startSendingSubscription",
    fa: "fa-envelope"
  }
];

export const profitabilitySubscriptionData  = {
  tables: {
    type: "",
    isNotRequired: true
  },
  profitability: {
    type: "checkbox",
    isNotRequired: true
  },
  hourlyRate: {
    type: "checkbox",
    isNotRequired: true
  },
  duration: {
    type: "checkbox",
    isNotRequired: true
  },
  sendAtMonthDay: {
    type: "array"
  },
  everyDay: {
    type: "",
    isNotRequired: true
  },
  language: {
    type: "radioSection",
    isNotRequired: true,
    options: [
      {
        name: "en",
        label: "EN",
        value: "en"
      },
      {
        name: "de",
        label: "DE",
        value: "de"
      }
    ]
  }
};

export const overtimeSubscriptionData  = {
  language: {
    type: "radioSection",
    isNotRequired: true,
    options: [
      {
        name: "en",
        label: "EN",
        value: "en"
      },
      {
        name: "de",
        label: "DE",
        value: "de"
      }
    ]
  },
  sendAtMonthDay: {
    type: "array"
  },
  everyDay: {
    type: "",
    isNotRequired: false
  },
  orderBy: {
    type: "select",
    isNotRequired: false
  },
  team: {
    type: "checkbox",
    isNotRequired: true
  },
  teamRows: {
    type: "array",
    isNotRequired: false,
    visibleWhen: "team"
  },
  teamAcceptedOvertimeThreshold: {
    type: "hour",
    isNotRequired: true,
    visibleWhen: "team"
  },
  teamReportedOvertimeThreshold: {
    type: "hour",
    isNotRequired: true,
    visibleWhen: "team"
  },
  teamCumulatedOvertimeThreshold: {
    type: "hour",
    isNotRequired: true,
    visibleWhen: "team"
  },
  employee: {
    type: "checkbox",
    isNotRequired: true
  },
  employeeRows: {
    type: "array",
    isNotRequired: false,
    visibleWhen: "employee"
  },
  employeeAcceptedOvertimeThreshold: {
    type: "hour",
    isNotRequired: true,
    visibleWhen: "employee"
  },
  employeeReportedOvertimeThreshold: {
    type: "hour",
    isNotRequired: true,
    visibleWhen: "employee"
  },
  employeeCumulatedOvertimeThreshold: {
    type: "hour",
    isNotRequired: true,
    visibleWhen: "employee"
  }
};

export const overtimeRequestsAlertData = {
  language: {
    type: "radioSection",
    isNotRequired: true,
    options: [
      {
        name: "en",
        label: "EN",
        value: "en"
      },
      {
        name: "de",
        label: "DE",
        value: "de"
      }
    ]
  },
  teamId: {
    type: "select",
    isNotRequired: true
  },
  allTeams: {
    type: "checkbox",
    isNotRequired: true
  },
};

export const positionFieldsFlexibleWorknormFF = {
  siteName: "info",
  seniorityLevelName: "info",
  type: "info",
  mon: "info",
  tue: "info",
  wed: "info",
  thu: "info",
  fri: "info",
  sat: "info",
  sun: "info",
  validFrom: "info",
  validFor: "info",
};

export const positionWeekDays = {
  siteName: "hidden",
  seniorityLevel: "hidden",
  type: "hidden",
  mond: "info",
  tue: "info",
  wed: "info",
  thu: "info",
  fri: "info",
  sat: "info",
  sun: "info",
  validFrom: "hidden",
  validFor: "hidden"
};

export const positionDialogCardWeekTable = {
  standardWorkingHours: "label",
  mon: true,
  tue: true,
  wed: true,
  thu: true,
  fri: true,
  sat: true,
  sun: true
};

export const positionDataFlexibleWorknormFF  = {
  siteId: {
    type: "select"
  },
  seniorityLevel: {
    type: "select"
  },
  type: {
    type: "array",
  },
  standardWorkingHours: {
    type: "label",
    infoTooltip: true
  },
  hourlyWorkingHours: {
    type: "label",
    infoTooltip: true
  },
  mon: {
    type: "number"
  },
  tue: {
    type: "number"
  },
  wed: {
    type: "number"
  },
  thu: {
    type: "number"
  },
  fri: {
    type: "number"
  },
  sat: {
    type: "number"
  },
  sun: {
    type: "number"
  },
  validFrom: {
    type: "date"
  },
};

export const subordinateTeamsFields = {
  name: "info",
  main: "checkbox",
  active: "checkbox",
  archived: "chexkbox"
};

export const subordinateTeamsRowActions = [
  {
    name: "activate",
    functionName: "toggleSubordinateTeam",
    fa: "fa-plus",
    off: (team) => team.active || team.main
  },
  {
    name: "deactivate",
    functionName: "toggleSubordinateTeam",
    fa: "fa-trash",
    off: (team) => !team.active || team.main
  }
];
